import React from 'react';
import { formatNumber, plural } from '../../../utils/formatters';
import { SectionHead } from './shared';
import { GiftIcon, ArrowRightIcon } from './icons';

const guestsWord = (n) => plural(n, 'гостя', 'гостей', 'гостей');

/**
 * Бонусы и охват — то, что есть только у программы лояльности iiko.biz.
 * Бонусы на счетах гостей под риском — готовый повод написать: «у вас
 * N бонусов, приходите». Охват — сколько гостей вообще можно пригласить.
 */
const ProgramBlock = ({ balance, reach, onOpenGuests }) => {
  if (!balance && !reach) return null;
  return (
    <section className="panel crma-section">
      <SectionHead
        icon={<GiftIcon size={18} className="heading-icon" />}
        title="Бонусы и охват"
        sub="По данным программы лояльности iiko.biz"
      />
      <div className="crma-program">
        {balance && (
          <div className="crma-program-card">
            <span className="crma-program-label">Бонусов на счетах гостей</span>
            {/* числом, без ₽: в какой единице iiko.biz ведёт баланс (рубли или баллы), не проверено */}
            <span className="crma-program-value">{formatNumber(balance.total)}</span>
            <span className="crma-program-sub">
              у {formatNumber(balance.holders)} {guestsWord(balance.holders)}
            </span>
            {balance.risk_holders > 0 && (
              <div className="crma-program-hint">
                <p>
                  <b>{formatNumber(balance.risk_total)}</b> {plural(balance.risk_total, 'бонус', 'бонуса', 'бонусов')} — у {formatNumber(balance.risk_holders)}{' '}
                  {guestsWord(balance.risk_holders)} под риском. Напоминание о бонусах — повод вернуться.
                </p>
                <button className="ui-btn-ghost" onClick={() => onOpenGuests({ status: 'risk' })}>
                  Под риском <ArrowRightIcon size={14} />
                </button>
              </div>
            )}
          </div>
        )}
        {reach && (
          <div className="crma-program-card">
            <span className="crma-program-label">Можно пригласить в акцию</span>
            <span className="crma-program-value">{formatNumber(reach.promo_ok)}</span>
            <span className="crma-program-sub">
              из {formatNumber(reach.active_year)} {guestsWord(reach.active_year)}, бывших за год
            </span>
            <p className="crma-note">
              Согласие на обработку данных есть у {formatNumber(reach.consent)}; из них{' '}
              {formatNumber(reach.promo_ok)} разрешили присылать им акции.
            </p>
          </div>
        )}
      </div>
    </section>
  );
};

export default ProgramBlock;
